import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm uppercase tracking-[0.2em] text-neutral-500">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role === "owner" && user.role !== "owner" && user.role !== "admin") {
    return <Navigate to="/become-host" replace />;
  }
  return children;
}
